import { DateUtil } from "../shared/date_util";

export class File {

    private _file_name: string = "";
    private _name: string = "";
    private _generation: string = "";
    private _size: number = 0;
    private _created_timestamp: Date = new Date();
    private _updated_timestamp: Date = new Date();
    private _expires_date: Date | string = "";

    public get file_name(): string {
        return this._file_name;
    }

    public set file_name(value: string) {
        this._file_name = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get generation(): string {
        return this._generation;
    }

    public set generation(value: string) {
        this._generation = value;
    }

    public get size(): number {
        return this._size;
    }

    public set size(value: number) {
        this._size = value;
    }

    public get sizeInKb(): number {
        return Math.ceil(this.size / 1024)
    }

    public get created_timestamp(): Date {
        return this._created_timestamp;
    }

    public set created_timestamp(value: any) {
        this._created_timestamp = DateUtil.getDateFromValue(value, false);
    }

    public get updated_timestamp(): Date {
        return this._updated_timestamp;
    }
    public set updated_timestamp(value: any) {
        this._updated_timestamp = DateUtil.getDateFromValue(value, false);
    }

    public get expires_date(): Date | string {
        return this._expires_date;
    }

    public set expires_date(value: any) {
        this._expires_date = DateUtil.getDateFromValue(value, false);
    }
}
